/** Comprueba el tamaño de una contraseña */
export const checkPasswordLength = (password: string, length: number): boolean => {
  return String(password).length >= length;
};
/** Comprueba la existencia de mayúsculas en una contraseña */
export const checkPasswordUppercase = (password: string): boolean => {
  const regex = /(?=.*[A-Z])/;
  return regex.test(password);
};
/** Comprueba la existencia de minúsculas en una contraseña */
export const checkPasswordLowercase = (password: string): boolean => {
  const regex = /(?=.*[a-z])/;
  return regex.test(password);
};
/** Comprueba la existencia de números en una contraseña */
export const checkPasswordNumbers = (password: string): boolean => {
  const regex = /(?=.*\d)/;
  return regex.test(password);
};
/** Comprueba la existencia de caracteres especiales en una contraseña */
export const checkPasswordSpecialChars = (password: string): boolean => {
  const regex = /(?=.*[!@#$%^&*()_+¡¿?])/;
  return regex.test(password);
};
